export default __webpack_public_path__ + "images/27346c97fc3110fff1765976ea3436ae.svg";